import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import studentSlice from '../features/student/studentsSlice'
import formSlice from '../features/form/formSlice'
import dashboardSlice from '../features/dashboard/dashboardSlice'


const combinedReducer = {
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  modal : modalSlice,
  studentsList : studentSlice,
  formData: formSlice,
  dashboard: dashboardSlice
}

export default configureStore({
    reducer: combinedReducer
})